/**
 * Backlog（AIRCLOSET プロジェクト）バグチケットの共有定数。issues_normalized ミラーへの重複スキャン
 * （新規バグ起票前チェック）と、チケット URL 生成に使う。MCP と PIL で同じ値を参照する単一 source。
 * @graph-stack ops-core
 * @graph-domain Operations
 * @graph-business Backlog バグチケット（案件起因バグ / 潜在バグ）の issue type id・スペース URL・チケット URL 生成と、ステータスの対応中 / 対応済み判定。新規バグ起票前の重複スキャンと起票前チェック（対応済みバグへの一致 = 再発）で共有
 * @graph-connects none
 */
/** Backlog バグチケットの issue type id（案件起因バグ 721649 / 潜在バグ 721648）。 @graph-connects none */
export const OPS_BUG_ISSUE_TYPE_IDS = [721649, 721648];
/** air-closet の Backlog スペース URL。 @graph-connects none */
export const OPS_BACKLOG_SPACE_URL = 'https://air-closet.backlog.jp';
/** issue key（例: AIRCLOSET-1234）から Backlog チケット URL を作る。 @graph-connects none */
export function backlogIssueUrl(issueKey) {
    return `${OPS_BACKLOG_SPACE_URL}/view/${issueKey}`;
}
/**
 * 対応済みとみなす Backlog ステータス id（3 = 処理済み / 4 = 完了。Backlog 既定のステータス）。
 * 開発完了・結合 / 総合テスト完了等のカスタムステータスはリリース前なので対応中に倒す。
 * @graph-connects none
 */
export const OPS_BACKLOG_DONE_STATUS_IDS = [3, 4];
/** 対応済みとみなす Backlog ステータス名（status_id が取れない行のフォールバック）。 @graph-connects none */
const DONE_STATUS_NAMES = ['処理済み', '完了'];
/**
 * Backlog バグの進行区分を返す。対応済みのバグに一致した事象は「再発」なので起票対象、対応中のバグに
 * 一致した事象は既知なので起票不要、という起票前チェックの判定に使う。id を優先し、取れない行は名前で判定する。
 * @graph-connects none
 */
export function classifyBacklogBugStatus(statusId, statusName) {
    if (statusId !== null)
        return OPS_BACKLOG_DONE_STATUS_IDS.includes(statusId) ? 'done' : 'open';
    return statusName !== null && DONE_STATUS_NAMES.includes(statusName.trim()) ? 'done' : 'open';
}
//# sourceMappingURL=backlog.js.map